<template>
    <div class="uk-padding-large" style="background-color: rgb(51, 51, 51); margin-bottom: -45px;">
        <div class="uk-container">
            <h3 class="uk-light uk-text-center uk-text-small@s">Where some of our graduates go</h3>
            <div class="uk-position-relative uk-visible-toggle uk-light uk-margin-medium-bottom" tabindex="-1" uk-slider="sets: true; center: true">

                <ul class="uk-slider-items uk-child-width-1-3 uk-child-width-1-4@m uk-child-width-1-5@l uk-child-width-1-6@xl">
                    <li>
                        <img src="../../assets/ncblogo.png" class="top" style="max-width: 70px; max-height: 70px; height: auto; width: auto;" alt="">

                    </li>
                    <li>
                        <img src="../../assets/jn_group.png" style="max-width: 120px; max-height: 120px; height: auto; width: auto; margin-top: 10px" alt="">

                    </li>
                    <li>
                        <img src="../../assets/tvj_logo.png"  class="top" style="max-width: 70px; max-height: 70px; height: auto; width: auto; " alt="">

                    </li>
                    <li>
                        <img src="../../assets/digicel.png" style="max-width: 110px; max-height: 110px; height: auto; width: auto; margin-top: 10px" alt="">

                    </li>
                    <li>
                        <img src="../../assets/pepsi.png" class="top" style="max-width: 110px; max-height: 110px; height: auto; width: auto; margin-top: -10px " alt="">

                    </li>

                </ul>

                <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
                <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next"></a>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "whereAreOurGrads"
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h3{
            font-size: 1.4em !important;
        }
        p{
            font-size: 0.7em !important;
        }
       img{
           height: 40px !important;
       }
      .top{
          margin-top: 10px !important;
      }
    }
</style>
